import React from 'react'

const Hero = () => {
  return (
    <div className='bg-[#fafafa] flex flex-col items-center py-24'>
      <h1 className='text-[42px] font-bold leading-[66px] text-[#211f54] w-full md:w-[50%] px-4 text-center mb-4'>LIVING IN NATURE <br /> NEVER FELT SO GOOD!</h1>
      <p className='text-[#6e7191] text-[16px] md:text-[18px] w-full md:w-1/2 text-center px-4'>Our suites are purpose built for living in nature. A minimalist lifestyle with just the right amount of modern lux amenities within a suite designed for long term living. Our sustainable suites provide the healthy environment for our communities lifestyle.</p>
    </div>
  )
}

export default Hero